define.alias("shared/components/shared/profile-categorization/categorize-steps", "preview-grid/components/shared/profile-categorization/categorize-steps");